import React, { useEffect, useState } from 'react'
import { getPostById } from './request';
import Post from './Post';
import { useParams } from 'react-router';
import Page from './Page';
import Breadcrumbs  from './Breadcrumbs';

const PostRead = () => {
    const _id = useParams()['_id'];
    const [post, setPost] = useState(null);

    useEffect(()=>{
        (async ()=>{
            try{
                setPost(await getPostById({ _id }));
            }catch(e){
                ;
            }

        })();
    },[]);

    return (
            <content>
                    {post && <Post {...post}></Post>}
            </content>
    )
}

export default PostRead;